import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Assessment from "@/pages/Assessment";
import AssessmentResult from "@/pages/AssessmentResult";
import Dashboard from "@/pages/Dashboard";
import Opportunities from "@/pages/Opportunities";
import OpportunityDetail from "@/pages/OpportunityDetail";
import NewOpportunity from "@/pages/NewOpportunity";
import MyVolunteering from "@/pages/MyVolunteering";
import OrganizerQueue from "@/pages/OrganizerQueue";
import Marketplace from "@/pages/Marketplace";
import ListingDetail from "@/pages/ListingDetail";
import NewListing from "@/pages/NewListing";
import Transactions from "@/pages/Transactions";
import About from "@/pages/About";
import Foundations from "@/pages/Foundations";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import Profile from "@/pages/Profile";
import MarketLanding from "@/pages/MarketLanding";

const IS_MARKET_HOST = /(^|\.)bahoimarket\.com$/i.test(window.location.hostname);

function RootRoute() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-app text-ink-soft">Loading…</div>
    );
  }
  if (user && typeof user === "object") {
    return <Navigate to="/dashboard" replace />;
  }
  return IS_MARKET_HOST ? <MarketLanding /> : <Landing />;
}

function MarketRoute() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-app text-ink-soft">Loading…</div>
    );
  }
  if (user && typeof user === "object") {
    return <Navigate to="/dashboard" replace />;
  }
  return <MarketLanding />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="/market" element={<MarketRoute />} />
            <Route path="/about" element={<About />} />
            <Route path="/foundations" element={<Foundations />} />
            <Route path="/how-it-works" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/assessment" element={<ProtectedRoute><Assessment /></ProtectedRoute>} />
            <Route path="/assessment/result" element={<ProtectedRoute><AssessmentResult /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/opportunities/new" element={<ProtectedRoute><NewOpportunity /></ProtectedRoute>} />
            <Route path="/opportunities/:id/edit" element={<ProtectedRoute><NewOpportunity /></ProtectedRoute>} />
            <Route path="/opportunities/:id" element={<OpportunityDetail />} />

            <Route path="/my-volunteering" element={<ProtectedRoute><MyVolunteering /></ProtectedRoute>} />
            <Route path="/organize" element={<ProtectedRoute><OrganizerQueue /></ProtectedRoute>} />

            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/marketplace/new" element={<ProtectedRoute><NewListing /></ProtectedRoute>} />
            <Route path="/marketplace/:id/edit" element={<ProtectedRoute><NewListing /></ProtectedRoute>} />
            <Route path="/marketplace/:id" element={<ListingDetail />} />

            <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
